import { Fragment, useState } from 'react';
import { useNotify, useRedirect, useRecordContext } from 'react-admin';
import { rpcClient } from 'transport-layer';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';


const PasswordChangeDialog = (props) => {
  const [open, setOpen] = useState(false);
  const record = useRecordContext();
  const redirect = useRedirect();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
	
  const handlePasswordChange = event => {
      setPassword(event.target.value);
  };
  const handleNewPasswordChange = event => {
      setNewPassword(event.target.value);
  };
  const handleNewPasswordChange2 = event => {
      setNewPassword2(event.target.value);
  };

  const handleUpdatePasswordClick = () => {
      setLoading(true);
      
      const options = {}
      if (newPassword === newPassword2) {
          options.body = JSON.stringify({
              email: record.email,
              password: password,
              new_password: newPassword
          })
          rpcClient('update_password', options)
          .then((e) => {
              notify('Password Updated');
              alert('Redirecting to login, please log back in.')
              setTimeout(e => {
                  redirect('/login');
              }, 500)
          })
          .catch((e) => {
              notify('Password Not Updated.  Try again.', 'warning')
          })
          .finally(() => {
              setLoading(false);
          });
      } else {
          alert('New passwords do not match.');
      }

  };


  return (
		<Fragment>
			<Button variant="outlined" onClick={(e) => setOpen(!open)} style={{ maxWidth: 200 }}>
				Change password
			</Button>

			<Dialog
				open={open}
				onClose={(e) => setOpen(false)}
				aria-labelledby="form-dialog-title"
				maxWidth="lg"
				fullWidth
			>
				<DialogTitle id="form-dialog-title">Change Password</DialogTitle>
				<DialogContent>
					<div style={{ display: 'flex', flexDirection: 'column', gap: '1em', justifyContent: 'flex-start' }}>
						<TextField
							id="current-password"
							type="password"
							label="Current Password"
							autoComplete="current-password"
							variant="filled"
							onChange={handlePasswordChange}
							fullWidth
							disabled={loading}
						/>

						<TextField
							id="new-password-1"
							type="password"
							label="New Password"
							autoComplete="new-password"
							variant="filled"
							onChange={handleNewPasswordChange}
							fullWidth
							disabled={loading}
						/>

						<TextField
							id="new-password-2"
							type="password"
							label="Re-type New Password"
							autoComplete="new-password"
							variant="filled"
							onChange={handleNewPasswordChange2}
							fullWidth
							disabled={loading}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={(e) => setOpen(false)}
						style={{ maxWidth: 200 }}
						color="secondary"
					>
						Close
					</Button>
					<Button
						onClick={handleUpdatePasswordClick}
						disabled={loading}
						style={{ maxWidth: 200 }}
					>
						Update Password
					</Button>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
}

export default PasswordChangeDialog;